import { useNavigate, useParams } from 'react-router-dom'
import { Badge } from 'react-daisyui'
import { Button } from '@/components/Button.tsx'
import { IconShoppingCart, IconPackage } from '@tabler/icons-react'
import { useBasket } from '@/contexts/basketContext.tsx'
import { useDrives } from '@/stores/useDrives.ts'
import { useShopBrand } from '@/contexts/shopBrandContext.tsx'

export default function ShopHeader() {
  const navigate = useNavigate()
  const { driveId } = useParams<{ driveId: string }>()
  const { basket } = useBasket()
  const { currentDrive } = useDrives()
  const isDemo = currentDrive && currentDrive.is_demo
  const brand = useShopBrand()

  const handleShopClick = () => {
    navigate(`/d/${driveId}/shop`)
  }

  const handleBasketClick = () => {
    navigate(`/d/${driveId}/shop/basket`)
  }

  const handleOrdersClick = () => {
    navigate(`/d/${driveId}/shop/orders`)
  }

  const basketItemCount = basket?.items_count || 0

  return (
    <div className="bg-base-100 border-b border-base-300 sticky top-0 z-50">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          {/* Left side - Shop title */}
          <div className="flex items-center">
            <button
              className="text-xl font-bold hover:opacity-80 transition-opacity cursor-pointer"
              onClick={handleShopClick}
            >
              {brand.name} Shop
            </button>
          </div>

          {/* Right side - Basket and Orders */}
          {
            !isDemo &&
            <div className="flex items-center gap-2">
              <Button
                color="ghost"
                size="sm"
                onClick={handleOrdersClick}
                className="flex items-center gap-2"
              >
                <IconPackage size={20} />
                <span className="hidden sm:inline">Meine Bestellungen</span>
              </Button>

              <Button
                color="ghost"
                size="sm"
                onClick={handleBasketClick}
                className="flex items-center gap-2 relative"
              >
                <div className="relative">
                  <IconShoppingCart size={20} />
                  {basketItemCount > 0 && (
                    <Badge
                      color="primary"
                      size="sm"
                      className="absolute -top-3 -right-3 min-w-5 h-5 flex items-center justify-center text-xs"
                    >
                      {basketItemCount}
                    </Badge>
                  )}
                </div>
                <span className="hidden sm:inline">Warenkorb</span>
              </Button>
            </div>
          }</div>
      </div>
    </div>
  )
}
